<ls-section-band
  [tinted]="tinted()"
  [eyebrow]="texts().eyebrow | translate"
  [heading]="texts().heading | translate"
  [moreLabel]="'SECTIONS.LISTS.MORE' | translate"
  [moreLink]="texts().link">
  <ls-lyric-list-section [mode]="mode()" />
</ls-section-band>
